import types from '../constants/emailConstants';

export const getEmailAction = (data) => ({
  type: types.GET_EMAIL,
  payload: data,
});

export const setEmailAction = (data) => ({
  type: types.SET_EMAIL,
  payload: data,
});

export const getEmailDetailAction = (data) => ({
  type: types.GET_EMAIL_DETAIL,
  payload: data,
});

export const setEmailDetailAction = (data) => ({
  type: types.SET_EMAIL_DETAIL,
  payload: data,
});

export const setEmailDetailErrorAction = () => ({
  type: types.SET_EMAIL_DETAIL_ERROR,
});

export const deleteEmailAction = (data) => ({
  type: types.DEL_EMAIL,
  payload: data,
});

export const sendLandlordInviteEmailAction = (data) => ({
  type: types.INVITE_LANDLORD,
  payload: data,
});
